import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {getMediaPath} from "../../app/functions";

import './index.scss';

import * as Routes from '../../constants/routes';
import * as Actions from '../../redux/actions';
//assets
import dog from 'assets/icons/dog-runnig.svg';

const ThanksPage = (props) =>{

    const dispatch = useDispatch();

    const text = useSelector(store => store.config.Translations);
    const userData = useSelector(store => store.config.UserData);
    const orderStatus = useSelector(store => store.config.OrderIsDone);

    useEffect(()=>{

        return () =>{
            dispatch(Actions.setOrderDone(false));
        }
    },[]);

    const handleLinkOnClick = () =>{
        props.history.push(Routes.home);
    };

    const handleViewOrder = () =>{
        props.history.push(Routes.personal_zone + Routes.personal_zone_routes.my_orders + '/' + orderStatus.order_id);
    };

    return(
        <section className='thanks-page'>
            <img src={getMediaPath(dog)} alt={text['thanks_title']}/>
            <h2 className='title'>{text['thanks_title']}</h2>
            <div className='text'>{userData.first_name + ', ' + text['thanks_text']}</div>
            <button className='order-btn' onClick={handleViewOrder}>{text['thanks_btn']}</button>
            <span className='home-link' onClick={handleLinkOnClick}>{text['thanks_link']}</span>
        </section>
    )
};

export default ThanksPage;